import React from 'react';
import './Menu.css';
import { Seo, buildBreadcrumbSchema } from '../components/Seo';

const publicUrl = process.env.PUBLIC_URL || '';
const menuPdf = `${publicUrl}/saritas-menu-2026-10-02.pdf`;

function Menu() {
    const embeddedMenuPdf = `${menuPdf}#view=FitH`;

    return (
        <div className='menu-page'>
            <Seo
                title='Speisekarte'
                description='Entdecken Sie die aktuelle Speisekarte von Sarita&apos;s in Hinwil als PDF mit Kaffee, Brunch, Lunch, hausgemachten Desserts und saisonalen Angeboten.'
                path='/menu'
                schema={[
                    buildBreadcrumbSchema([
                        { name: 'Startseite', path: '/' },
                        { name: 'Speisekarte', path: '/menu' }
                    ])
                ]}
            />
            <header className='page-hero menu-hero'>
                <div className='container page-hero__content'>
                    <h1 className='page-hero__title'>Speisekarte</h1>
                </div>
            </header>

            <div className='section-shell'>
                <div className='container'>
                    <section className='menu-pdf panel-surface' aria-labelledby='menu-pdf-title'>
                        <div className='menu-pdf__header'>
                            <div className='menu-pdf__copy'>
                                <h2 id='menu-pdf-title'>Aktuelle Speisekarte</h2>
                                <p className='menu-pdf__text'>
                                    Die vollständige Speisekarte ist direkt auf dieser Seite eingebettet. Falls die Vorschau auf
                                    deinem Gerät nicht angezeigt wird, kannst du die PDF auch separat öffnen oder herunterladen.
                                </p>
                            </div>
                            <div className='menu-pdf__actions'>
                                <a className='menu-pdf__action' href={menuPdf} target='_blank' rel='noreferrer'>
                                    PDF öffnen
                                </a>
                                <a className='menu-pdf__action menu-pdf__action--secondary' href={menuPdf} download>
                                    PDF herunterladen
                                </a>
                            </div>
                        </div>

                        <div className='menu-pdf__viewer-shell'>
                            <object className='menu-pdf__viewer' data={embeddedMenuPdf} type='application/pdf' aria-label='Speisekarte als PDF'>
                                <p className='menu-pdf__fallback'>
                                    Die PDF-Vorschau wird von diesem Browser nicht unterstützt.{' '}
                                    <a href={menuPdf} target='_blank' rel='noreferrer'>
                                        Menü als PDF öffnen
                                    </a>
                                </p>
                            </object>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}

export default Menu;
